import React from "react";
import { Col, Divider, Progress, Rate, Row } from "antd";
import { internationalizeNumericValue } from "@ts/utils";
import { IRatingsWidget } from "@ts/common-types";
import WidgetCard from "./WidgetCard";
import { roundToDynamicPrecisionForRating } from "@ts/widget";

const RatingsWidget: React.FC<IRatingsWidget> = ({ widgetData, type }) => {
    return (
        <WidgetCard
            className={`h-100 ${type === "widget" ? "rounded-2" : ""}`}
        >
            <div>
                <h5>
                    Customer Reviews{" "}
                    <span
                        className="text-muted"
                        style={{
                            fontSize: "14px",
                        }}
                    >
                        (Last 90 days ago)
                    </span>
                </h5>
                <Rate value={roundToDynamicPrecisionForRating(+widgetData?.rating || 0)} allowHalf disabled />
                <h5 className="d-inline ms-3">{widgetData?.rating || "-"}</h5>
            </div>
            <Divider style={{ margin: "10px 0" }} />
            <div>
                <strong
                    className="d-inline me-3"
                    style={{
                        fontSize: "18px",
                    }}
                >
                    {widgetData?.rating_count
                        ? internationalizeNumericValue(widgetData?.rating_count)
                        : "-"}
                </strong>
                <span>Total no. of Reviews</span>
            </div>
            <Divider style={{ margin: "10px 0" }} />
            <div>
                {widgetData &&
                    Object.entries(widgetData?.ratingDistribution).map(
                        ([key, value]) => (
                            <Row className="star-item" key={key}>
                                <Col span={4}>
                                    <span>{key}</span>
                                </Col>
                                <Col span={20}>
                                    <Progress
                                        percent={+value}
                                        strokeColor={"#FF8F00"}
                                        strokeWidth={30}
                                        strokeLinecap="square"
                                    />
                                </Col>
                            </Row>
                        )
                    )}
            </div>
        </WidgetCard>
    );
};

export default RatingsWidget;